import VCF from './parse';
export function parseBreakend(breakendString) {
  var tokens = breakendString.split(/[[\]]/);
  if (tokens.length > 1) {
    var MateDirection = breakendString.includes('[') ? 'right' : 'left';
    var Join;
    var Replacement;
    var MatePosition;
    for (var i = 0; i < tokens.length; i += 1) {
      var tok = tokens[i];
      if (tok) {
        if (tok.includes(':')) {
          // this is the remote location
          MatePosition = tok;
          Join = Replacement ? 'right' : 'left';
        } else {
          // this is the local alteration
          Replacement = tok;
        }
      }
    }
    if (!(MatePosition && Join && Replacement)) {
      throw new Error("Invalid breakend: ".concat(breakendString));
    }
    return {
      MatePosition: MatePosition,
      Join: Join,
      Replacement: Replacement,
      MateDirection: MateDirection
    };
  } else {
    if (breakendString.startsWith('.')) {
      return {
        Join: 'left',
        SingleBreakend: true,
        Replacement: breakendString.slice(1)
      };
    } else if (breakendString.endsWith('.')) {
      return {
        Join: 'right',
        SingleBreakend: true,
        Replacement: breakendString.slice(0, breakendString.length - 1)
      };
    } else if (breakendString[0] === '<') {
      var res = breakendString.match('<(.*)>(.*)');
      if (!res) {
        throw new Error("failed to parse ".concat(breakendString));
      }
      var _Replacement = res === null || res === void 0 ? void 0 : res[2];
      return _Replacement ? {
        Join: 'left',
        Replacement: _Replacement,
        MateDirection: 'right',
        MatePosition: "<".concat(res === null || res === void 0 ? void 0 : res[1], ">:1")
      } : undefined;
    } else if (breakendString.includes('<')) {
      var _res = breakendString.match('(.*)<(.*)>');
      if (!_res) {
        throw new Error("failed to parse ".concat(breakendString));
      }
      var _Replacement2 = _res === null || _res === void 0 ? void 0 : _res[1];
      return _Replacement2 ? {
        Join: 'right',
        Replacement: _Replacement2,
        MateDirection: 'right',
        MatePosition: "<".concat(_res === null || _res === void 0 ? void 0 : _res[2], ">:1")
      } : undefined;
    }
  }
  return undefined;
}
export default VCF;